package com.gsb.vyapar.bhagya.presentation.business.util

import com.gsb.vyapar.bhagya.datasource.cache.SqlDelightClient
import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.Categories
import com.gsb.vyapar.bhagya.domain.*
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.interactor.util.*
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.dialog.Dialogs
import com.gsb.vyapar.bhagya.presentation.dialog.uistate.DialogUiState
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.util.*
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlin.coroutines.resume
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

fun addBusinessUI(
    isAdmin: Boolean,
    logo: String,
    name: String,
    category: Categories.D.Category,
    subCategories: List<SubCategories.D.SubCategory>,
    description: String,
    services: String,
    address: String,
    pincode: String,
    latitude: String,
    longitude: String,
    image1: String,
    image2: String,
    image3: String,
    image4: String,
    image5: String,
    email: String,
    phone1: String,
    phone2: String,
    website: String,
    gmap: String,
    fb: String,
    insta: String,
    x: String,
    linkedIn: String,
    youtube: String,
    delete: Boolean,
) {
    if (isWebsiteError(logo) || logo.isEmpty()) {
        showError("Select Business Logo / Picture")
    } else if (isBusinessNameError(name) || name.isEmpty()) {
        showError("Enter valid business name")
    } else if (category.id == 0L) {
        showError("Please select a category")
    } else if (subCategories.isEmpty()) {
        showError("Please select subcategories")
    } else if (isDetailError(description) || description.isEmpty()) {
        showError("Enter valid business description")
    } else if (isAddressError(address) || address.isEmpty()) {
        showError("Enter valid business address")
    } else if (isPincodeError(pincode) || pincode.isEmpty()) {
        showError("Enter valid business pincode")
    } else if (isEmailError(email) || email.isEmpty()) {
        showError("Enter valid business email")
    } else if (isMobileError(phone1) || phone1.isEmpty()) {
        showError("Enter valid business Contact Number 1")
    } else if (isDetailError(services)) {
        showError("Enter valid business services")
    } else if (isLatitudeError(latitude) || latitude.isEmpty()) {
        showError("Enter valid business latitude")
    } else if (isLongitudeError(longitude) || longitude.isEmpty()) {
        showError("Enter valid business longitude")
    } else if (isMobileError(phone2)) {
        showError("Enter valid business Contact Number 2")
    } else if (isWebsiteError(website)) {
        showError("Enter valid business website")
    } else if (isGMapError(gmap)) {
        showError("Enter valid business Google Maps Link")
    } else if (isFbError(fb)) {
        showError("Enter valid business Facebook link")
    } else if (isInstaError(insta)) {
        showError("Enter valid business Instagram link")
    } else if (isXError(x)) {
        showError("Enter valid business X link")
    } else if (isLinkedInError(linkedIn)) {
        showError("Enter valid business LinkedIn link")
    } else if (isYoutubeError(youtube)) {
        showError("Enter valid business Youtube link")
    } else {
        var isNew = false
        val tempId: String = getBusinessUiState().addEditBusiness.getTempId().ifEmpty { getRandomIntString() }
        val userId: String = getBusinessUiState().addEditBusiness.getUserId().ifEmpty { getState().getUser().getId() }
        val id: String = getBusinessUiState().addEditBusiness.getId()
        val created: String = getBusinessUiState().addEditBusiness.getCreated().ifEmpty { getPresentTimeString() }
        var businessMap =
            getBusinessUiState().addEditBusiness.d.data +
                    (TEMP_ID to tempId) +
                    (USERID to userId) +
                    (CREATED to created) +
                    (UPDATED to getPresentTimeString()) +
                    (NAME to name) +
                    (DESCRIPTION to description) +
                    (SERVICE to services) +
                    (CATEGORY_ID to category.id.toString()) +
                    (SUB_CATEGORY_IDS to subCategories.map { it.id }.joinToString()) +
                    (PINCODE to pincode) +
                    (ADDRESS to address) +
                    (LATITUDE to latitude) +
                    (LONGITUDE to longitude) +
                    (LOGO to logo) +
                    (IMAGE1 to image1) +
                    (IMAGE2 to image2) +
                    (IMAGE3 to image3) +
                    (IMAGE4 to image4) +
                    (IMAGE5 to image5) +
                    (EMAIL to email) +
                    (PHONE1 to phone1) +
                    (PHONE2 to phone2) +
                    (WEBSITE to website) +
                    (FACEBOOK to fb) +
                    (INSTAGRAM to insta) +
                    (X to x) +
                    (MAP to gmap) +
                    (YOUTUBE to youtube) +
                    (LINKEDIN to linkedIn)
        if (id.isNotEmpty()) {
            businessMap = businessMap + (ID to id)
        }
        businessMap = businessMap + (DELETED to if (delete) DELETED else "")
        if (isAdmin) {
            if (id.isEmpty()) {
                isNew = true
                businessMap = businessMap + (ID to getState().getNextBusinessId().toU())
            }
            saveBusinessToBackend(businessMap) {
                showSuccess("Business details saved")
                deleteMBusiness(it) {
                    showSuccess("MBusiness deleted")
                    popView()
                    if (isNew) saveConfigAfterAdd()
                }
            }
        } else {
            saveMBusinessToBackend(businessMap) {
                showSuccess("Business details has been sent for Review")
                popView()
                getMBusinessUserUI()
            }
        }
    }
}

fun deleteMBusinessUI(business: Business) {
    deleteMBusiness(business) {
        showSuccess("MBusiness deleted")
        popView()
    }
}

fun getLocation(pincode: String, success: (Location) -> Unit) {
    if (isValidPincode(pincode)) {
        showLoading()
        launchDefault {
            val result = KtorClient.getLocation(pincode)
            if (!result.isSuccess) {
                showError("Get Location failed ${result.exceptionOrNull()?.getMessage()}")
            } else {
                val locationResult = result.getOrNull()
                if (locationResult != null) {
                    success(locationResult)
                } else {
                    showError("Get Location failed null")
                }
            }
            hideLoading()
        }
    }
}

private fun deleteMBusiness(business: Business, success: () -> Unit) {
    showLoading()
    launchDefault {
        val result = KtorClient.deleteMBusiness(business)
        if (!result.isSuccess) {
            showError("Delete Business failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            success()
        }
        hideLoading()
    }
}

fun saveConfigAfterAdd() {
    showLoading()
    launchDefault {
        var config = getState().getConfig()
        config = config.copy(v = config.v + 1)
        val result = KtorClient.updateConfig(config)
        if (!result.isSuccess) {
            showError("Save Config failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            showSuccess("Config Updated")
        }
        hideLoading()
    }
}

private fun saveBusinessToBackend(businessMap: Map<String, String>, business: (Business) -> Unit) {
    showLoading()
    launchDefault {
        var newBusiness = getBusinessUiState().addEditBusiness
        newBusiness = newBusiness.copy(v = newBusiness.v + 1, u = newBusiness.getUserId(), d = Business.D(businessMap), i = businessMap.get(ID).orEmpty().fromU() ?: 0)
        val result = KtorClient.updateBusiness(newBusiness)
        if (!result.isSuccess) {
            showError("Save Business failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            business(newBusiness)
            SqlDelightClient.updateBusiness(newBusiness)
        }
        hideLoading()
    }
}

private fun saveMBusinessToBackend(businessMap: Map<String, String>, business: (Business) -> Unit) {
    showLoading()
    launchDefault {
        var newBusiness = getBusinessUiState().addEditBusiness
        newBusiness = newBusiness.copy(v = newBusiness.v + 1, u = newBusiness.getUserId(), d = Business.D(businessMap))
        val result = KtorClient.updateMBusiness(newBusiness)
        if (!result.isSuccess) {
            showError("Save MBusiness failed ${result.exceptionOrNull()?.getMessage()}")
        } else {
            business(newBusiness)
        }
        hideLoading()
    }
}

fun getMBusinessUserUI() {
    getBusinessUiState().updateIsRefreshing(true)
    showLoading()
    launchDefault {
        val result = KtorClient.getMBusinessUser(getState().getUser())
        if (!result.isSuccess) {
            //showError("Failed to fetch your pending businesses for Approval${result.exceptionOrNull()?.getMessage()}")
            getBusinessUiState().resetMBusinessList()
        } else {
            getBusinessUiState().updateMBusinessList(result.getOrNull()?.map { it.value.toBusiness() }.orEmpty())
        }
        hideLoading()
        getBusinessUiState().updateIsRefreshing(false)
    }
}

fun launchAddEditMBusiness(business: Business) {
    getBusinessUiState().updateAddEditBusiness(business)
    pushView(Screens.AddEditBusiness)
}

fun getCategoryName(categoryId: String): String {
    val categories = getState().getCategories().getCategoriesList()
    return categories.find { it.id.toString() == categoryId }?.name.orEmpty()
}

fun getSubCategories(subCategoryIds: String): List<String> {
    val subCategories = getState().getSubCategories().d.subCategories
    val restoredList = subCategoryIds.split(", ").mapNotNull { it.toIntOrNull() }
    return subCategories.filter { restoredList.contains(it.id.toInt()) }.map { it.name }
}

fun getBusinessIdUrl(id: String): String {
    return "b/${id}"
}

fun getBusiness(index: Int, business: (Business?) -> Unit) {
    val id = index.toU()
    val businessString = Preference.getCacheData(getBusinessIdUrl(id))
    if (businessString.isNullOrEmpty()) {
        launchDefault {
            val result = KtorClient.getBusiness(id)
            if (result.isSuccess) {
                val businessResult = result.getOrNull()
                if (businessResult != null) {
                    val finalBusiness = businessResult.toBusiness()
                    SqlDelightClient.updateBusiness(finalBusiness)
                    business(finalBusiness)
                } else {
                    business(null)
                }
            } else {
                business(null)
            }
        }
    } else {
        try {
            business(businessString.decodeBusinessString())
        } catch (e: Exception) {
            business(null)
        }
    }
}

/**
 * Suspended wrapper for [getBusiness] that returns the result directly.
 */
suspend fun getBusinessSuspend(index: Int): Business? =
    suspendCancellableCoroutine { cont ->
        getBusiness(index) { cont.resume(it) }
    }
fun getLatestBusiness(business: Business, businessCallback: (Business?) -> Unit) {
    if (getBusinessUiState().isBusinessFetched.value[business.getId()] != null) {
        businessCallback(getBusinessUiState().isBusinessFetched.value[business.getId()])
    } else {
        showLoading()
        launchDefault {
            val resultV = KtorClient.getBusinessVersion(business.getId())
            if (resultV.isSuccess) {
                val businessVersion = resultV.getOrNull()
                if (businessVersion != null) {
                    if (businessVersion > business.v) {
                        val result = KtorClient.getBusiness(business.getId())
                        if (result.isSuccess) {
                            val businessResult = result.getOrNull()
                            if (businessResult != null) {
                                val finalBusiness = businessResult.toBusiness()
                                SqlDelightClient.updateBusiness(finalBusiness)
                                getBusinessUiState().updateBusinessList(finalBusiness)
                                getBusinessUiState().isBusinessFetched.update { it + (business.getId() to finalBusiness) }
                                hideLoading()
                                businessCallback(getBusinessUiState().isBusinessFetched.value[business.getId()])
                            } else {
                                hideLoading()
                            }
                        } else {
                            hideLoading()
                        }
                    } else {
                        getBusinessUiState().isBusinessFetched.update { it + (business.getId() to business) }
                        hideLoading()
                        businessCallback(getBusinessUiState().isBusinessFetched.value[business.getId()])
                    }
                } else {
                    hideLoading()
                }
            } else {
                hideLoading()
            }
        }
    }
}

fun launchBusinessDetail(business: Business) {
    // Reset scroll state when launching details for a new business
    getBusinessUiState().updateBusinessDetailScroll(0)
    getBusinessUiState().updateBusiness(business)
    pushView(Screens.BusinessDetail)
}

fun launchBusinessDetail(businessId: String) {
    getBusinessUiState().businessList.find { it.getId() == businessId }?.let {
        // Reset scroll state when launching details for a new business
        getBusinessUiState().updateBusinessDetailScroll(0)
        getBusinessUiState().updateBusiness(it)
        pushView(Screens.BusinessDetail)
    }?: run {
        showError("Cannot find the business details")
    }
}

fun showGallery(images: List<String>, initialPage: Int) {
    getBusinessUiState().updateImages(images)
    getBusinessUiState().updateInitialPage(initialPage)
    pushView(Screens.Gallery)
}

fun isMyBusiness(business: Business): Boolean {
    val userId = getState().getUser().getId()
    return userId == business.getUserId()
}

fun hasBusiness(): Boolean {
    return getBusinessUiState().businessList.filter { it.getUserId() == getState().getUser().getId() && !it.isBusinessDeleted() }.isNotEmpty()
}

fun deleteBusinessPopup(continueDelete: () -> Unit) {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Regular, message = "Are you sure you want to delete business?", onCancelClick = {
        updateState(getState().copy(dialogUiState = null))
    }, onOKClick = {
        updateState(getState().copy(dialogUiState = null))
        continueDelete()
    })))
}

fun undoDeleteBusinessPopup(continueDelete: () -> Unit) {
    updateState(getState().copy(dialogUiState = DialogUiState(dialogType = Dialogs.Regular, message = "Are you sure you want to undo the deletion of this business? This action will restore the business and its associated data.", onCancelClick = {
        updateState(getState().copy(dialogUiState = null))
    }, onOKClick = {
        updateState(getState().copy(dialogUiState = null))
        continueDelete()
    })))
}